import { toConsumableArray as _toConsumableArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { createSelector } from 'reselect';
import { createLockedColumnsSelector } from './locked-columns-selector.esm.js';

var formatColumns = function formatColumns(lockedColumns, resources) {
  var and = resources.container.and ? resources.container.and() : ' and ';
  var comma = resources.container.comma ? resources.container.comma() : ', ';
  switch (lockedColumns.length) {
    case 0:
      return '';
    case 1:
      return "\"".concat(lockedColumns[0], "\"");
    default:
      {
        var clone = _toConsumableArray(lockedColumns);
        var last = clone.pop();
        return "".concat(clone.map(function (s) {
          return "\"".concat(s, "\"");
        }).join(comma)).concat(and, "\"").concat(last, "\"");
      }
  }
};
var toContainerText = function toContainerText(lockedColumns, resources) {
  var note = '';
  if (resources.container.note) {
    var numberOfColumns = lockedColumns.length;
    var columnNames = formatColumns(lockedColumns, resources);
    note = resources.container.note({
      columnNames: columnNames,
      numberOfColumns: numberOfColumns
    });
  }
  var descriptions = [resources.container.descriptions(), note].filter(function (s) {
    return s.length > 0;
  }).join('\n');
  return {
    apply: resources.container.apply(),
    cancel: resources.container.cancel(),
    reset: resources.container.reset(),
    title: resources.container.title(),
    descriptions: descriptions
  };
};
var createContainerTextSelector = function createContainerTextSelector() {
  var lockedColumnsSelector = createLockedColumnsSelector();
  return createSelector(lockedColumnsSelector, function (props) {
    return props.resources;
  }, toContainerText);
};

export { createContainerTextSelector };
//# sourceMappingURL=container-text-selector.esm.js.map
